<script setup lang="ts">
import type { KanbanLogActor } from '@entities/kanban-comment'
import type { TasksKanbanStage } from '@brighterly/lib-core-types/tasks-kanban/enums'

import { faArrowRight } from '@fortawesome/pro-regular-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'

import { KanbanLogItemInfo } from '@widgets/kanban-comments'
import { useListsStore } from '@shared/model'
import { IconContainer } from '@shared/ui/other'
import { BadgeKanbanStageStatus } from '@shared/ui/kanban'

import { TASKS_KANBAN_STAGE_COLOR } from '../config/tasks-kanban-stage-color.const'

defineOptions({
  name: 'TasksKanbanLogStatus',
})

defineProps<{
  actor: KanbanLogActor | null
  oldValue: string | null
  value: string | null
}>()

const listsStore = useListsStore()
const stageList = listsStore.getLists?.tasks_kanban?.lists?.status ?? {}
</script>

<template>
  <div class="kanban-log-field">
    <KanbanLogItemInfo
      :actor="actor"
      label="change stage"
    />
    <div class="kanban-log-field__row">
      <BadgeKanbanStageStatus
        v-if="oldValue"
        :text="stageList[oldValue] ?? oldValue"
        :color="TASKS_KANBAN_STAGE_COLOR[oldValue as TasksKanbanStage] ?? 'gray'"
      />
      <IconContainer v-if="oldValue && value">
        <FontAwesomeIcon :icon="faArrowRight" />
      </IconContainer>
      <BadgeKanbanStageStatus
        v-if="value"
        :text="stageList[value] ?? value"
        :color="TASKS_KANBAN_STAGE_COLOR[value as TasksKanbanStage] ?? 'gray'"
      />
    </div>
  </div>
</template>

<style scoped lang="scss" src="@shared/ui/kanban/styles/_kanban-log-field.scss" />